// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Client lib imports
const { localStorage } = require('client/lib/storage')

function isArticleModel(item) {
  return item.type === modelTypes.ARTICLE
}

const REPORTED_URL_IDS_KEY = 'reported_url_ids'

function getCachedReportedUrlIds() {
  const valueStr = localStorage.getItem(REPORTED_URL_IDS_KEY)
  if (valueStr) {
      return Array.from(JSON.parse(valueStr), String)
  }
  return []
}

function cacheReportedUrlId(urlId) {
  const valueArray = getCachedReportedUrlIds()
  valueArray.push(urlId)
  const valueStr = JSON.stringify(valueArray)
  localStorage.setItem(REPORTED_URL_IDS_KEY, valueStr)
}

module.exports = {
  isArticleModel,
  getCachedReportedUrlIds,
  cacheReportedUrlId
}
